import "./app.scss";
import Editprofile from "./components/Editprofile/Editprofile.js";
import Footer from "./components/landing/footer/Footer.js";
import Landing from "./components/landing/Landing.js";
import Wardah from "./components/Wardah/Wardah.js";
import Createtask from "./components/Createtask/Createtask.js";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Taskscreated from "./components/Taskscreated/Taskscreated.js";
import Tasksdetails from "./components/Tasksdetails/Tasksdetails.js";
import Similartaskdetail from "./components/Similartaskdetail/Similartaskdetail.js";
import LatestTask from "./components/landing/LatestTask/LatestTask.js";
import Raza from "./components/Raza/Raza.js";
import Taskparticipated from "./components/Taskparticipated/Taskparticipated.js";
import useEagerConnect from "./hooks/useEagerConnect";
import { ToastContainer } from "react-toastify";
import PerviewTask from "./components/Createtask/perviewTask.js";
import Allnotification from "./components/Allnotification.js/Allnotification.js";
import "./dist/quill.snow.css";
import Navbar from "./components/landing/header/Navbar.js";
import { SocketProvider } from "./contexts/SocketContext.js";
import Contactus from "./components/Contactus/Contactus.js";
import Faqs from "./components/Faqs/Faqs.js";
import Privacy from "./components/Privacy/Privacy.js";
import Terms from "./components/Terms/Terms.js";
import Error from "./components/Error404/Error.js";

import Coming from "./components/Comingsoon/Coming.js";
import { useEffect, useState } from "react";
import DisputeDetail from "./components/DisputeDetail/DisputeDetail.js";
import Blog from "./components/Blog/Blog.js";
import BlogDetail from "./components/Blog/BlogDetail.js";
import Notificationpreferences from "./components/Notificationpreferences/Notificationpreferences.js";
function App() {
  let [profile, setProfile] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  const isConnected = useEagerConnect(isMobile);

  useEffect(() => {
    const checkMobile = () => {
      const mobileCheck = window.innerWidth <= 991;
      setIsMobile(mobileCheck);
      localStorage.setItem("isMobile", mobileCheck);
    };

    // run on initial load
    checkMobile();

    // add resize listener to update mobile status
    window.addEventListener("resize", checkMobile);

    // Cleanup

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  useEffect(() => {
    if (isConnected) {
      console.log("Wallet Connected Successfully");
    }
  }, [isConnected]);

  return (
    <>
      <SocketProvider>
        <ToastContainer
          autoClose={5000}
          style={{ fontSize: 12, fontWeight: 300 }}
          theme="light"
          position="top-center"
        />
        <Router>
          <Navbar profile={profile} />
          <Routes>
            <Route path="/" exact element={<Landing />} />
            <Route path="/taskscreated" element={<Taskscreated />} />
            <Route path="/tasksdetails/:id" exact element={<Tasksdetails />} />
            <Route
              path="/similartaskdetail/:id"
              exact
              element={<Similartaskdetail />}
            />
            <Route path="/taskperview" exact element={<PerviewTask />} />
            {/* <Route exact path='/raza' element={<Raza />} />
          <Route exact path='/wardah' element={<Wardah />} /> */}
            <Route exact path="/createtask" element={<Createtask />} />
            <Route
              exact
              path="/editprofile"
              element={<Editprofile setProfile={setProfile} />}
            />
            <Route exact path="/latesttask" element={<LatestTask />} />
            <Route
              exact
              path="/taskparticipate"
              element={<Taskparticipated />}
            />
            <Route
              path="/allnotification"
              exact
              element={<Allnotification />}
            />
            <Route path="/contact-us" exact element={<Contactus />} />
            <Route path="/faq" exact element={<Faqs />} />
            <Route path="/privacy-policy" exact element={<Privacy />} />
            <Route path="/terms-of-use" exact element={<Terms />} />
            <Route path="/error404" exact element={<Error />} />
            <Route exact path="/comingsoon" element={<Coming />} />
            <Route exact path="/disputedetail" element={<DisputeDetail />} />
            <Route exact path="/blog" element={<Blog />} />
            <Route path="/blogdetail/:id" element={<BlogDetail />} />
            <Route path="*" element={<Navigate to="/error404" />} />
            <Route
              exact
              path="/notificationpreferences"
              element={<Notificationpreferences />}
            />
          </Routes>
          <Footer />
        </Router>
      </SocketProvider>
    </>
  );
}

export default App;
// <>
//  <ToastContainer autoClose={5000} style={{ fontSize: 12, fontWeight: 300 }} theme="light" position="top-center" />
//       <Router>
//         <Routes>
//           <Route exact path='/' element={<Landing />} />
//           <Route exact path='/taskscreated' element={<Taskscreated />} />
//           <Route exact path='/tasksdetails/:id' element={<Tasksdetails />} />
//           <Route exact path='/similartaskdetail/:id' element={<Similartaskdetail />} />
//           <Route exact path='/taskperview' element={<PerviewTask />} />
//           <Route exact path='/raza' element={<Raza />} />
//           <Route exact path='/wardah' element={<Wardah />} />
//           <Route exact path='/createtask' element={<Createtask />} />
//           <Route exact path='/editprofile' element={<Editprofile />} />
//           <Route exact path='/latesttask' element={<LatestTask />} />
//           <Route exact path='/taskparticipate' element={<Taskparticipated />} />
//           <Route exact path='/allnotification' element={<Allnotification />} />
//         </Routes>
//         <Footer />
//       </Router>
// </>

//